module.exports = __webpack_public_path__ + "static/media/superBlot-3.7f9af2b7.png";